import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const PortalAuthContext = createContext();

export const usePortalAuth = () => useContext(PortalAuthContext);

export const PortalAuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [portalUser, setPortalUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("portalToken");
    if (token) {
      setIsAuthenticated(true);
      storeUserData(token);
    } else {
      setIsAuthenticated(false);
    }
    setLoading(false);
  }, []);

  const login = (token) => {
    localStorage.setItem("portalToken", token);
    setIsAuthenticated(true);
    storeUserData(token);
    navigate("/portal/dashboard");
  };

  const logout = () => {
    localStorage.removeItem("portalToken");
    setIsAuthenticated(false);
    setPortalUser(null);
    navigate("/portal/login");
  };

  const storeUserData = (token) => {
    try {
      const decodedToken = jwtDecode(token);
      setPortalUser(decodedToken);
    } catch (error) {
      console.error("Invalid portal token", error);
      setIsAuthenticated(false);
    }
  };

  return (
    <PortalAuthContext.Provider value={{ isAuthenticated, loading, login, logout, portalUser }}>
      {children}
    </PortalAuthContext.Provider>
  );
};
